<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative mb-20 md:mb-0 ">
    <Pagesubtitle subTitle="Change the address of your feedback link to a domain or subdomain you own." />
    <div v-if="!$store.getters['dash/hasCustomDomainString']" class="text-center">
      <div class="inline-block w-100 my-20">
        <img class="mx-auto w-32" src="@/assets/images/misc/plan.png"/>
          <p  class="">No domains set up {{ $store.state.dash.isMulti ?  'for this location' : 'yet.' }}</p>
          <p class="text-lg my-8 font-medium ">Send us a message to link {{ $store.state.dash.isMulti ? 'this location to a domain' : 'your domain' }}. </p>          
          <p class="my-6 text-lg">We recommend using an address like <span class="italic font-medium">feedback.yourdomain.com</span> or registering a new domain.</p>       
          <vs-button class="w-full" @click="talkToUsDomain">Talk to us</vs-button>
          <p class="mt-6">You'll need access to your domain's DNS settings. First, we'll verify domain ownership with a TXT record, before adding A/AAAA records as a final step.</p>          
      </div>
    </div>
    <div v-else>
      <div class="vx-row nofilterimags">
        <!-- CARD 2: SUBSCRIBERS GAINED -->
        <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-base flex">
          <vx-card title="Associated domain/address" slot="no-body" class="text-center pt_sar_mid" >
            <div class="text-left mt-1">           
              <vs-input
              size="large"
              class="w-full darkinput"
              :value="$store.getters['dash/hasCustomDomainString']"
              :disabled="true"
              label="Feedback link address"              
              icon-pack="feather"
              icon="icon-link"
              />              
            </div>
          </vx-card>
        </div>
    </div>
  </div>
  </div>
</template>


<script>

import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

export default {
  data () {
    return {
      setupData: false
    }
  },
  methods: {
  talkToUsDomain() {

    window.Beacon('prefill', {
      subject: 'Link domain',
      text: `Hi, Please link [your chosen address] to ${this.$store.getters['dash/feedbackURL']}.`
    })

    this.chatToUs()

  }
  },
  components: {
    Savebutton,
    Pagesubtitle
  }
}
</script>

<style lang="scss">

.darkinput {
  input {
    opacity: 1 !important;
  }
}

</style>
